import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
    name: 'newlineToBr'
})
export class NewlineToBrPipe implements PipeTransform {
    transform(value: string): string {
        if (!value) return value; // Handle empty or null value
        return value.replace(/\n/g, '<br>'); // Replace newlines with <br>
    }
}